module.exports = __webpack_public_path__ + "img/icb-co-Inte-m@2x.14a4c20b.png";